import { render, staticRenderFns } from "./objPreview.vue?vue&type=template&id=108bd1b0&"
import script from "./objPreview.vue?vue&type=script&lang=js&"
export * from "./objPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports